import type { FC } from "react";

import classNames from "classnames";

import { UiCheckBoldIcon } from "@jti/brand-icons/ui-check-bold";
import { UiCrossIcon } from "@jti/brand-icons/ui-cross";

import type { TierStatusType } from "../TiersBenefits";

import styles from "./TierStatus.module.scss";

export type TierStatusProps = {
  status: TierStatusType;
  label: string;
  isHighLightened?: boolean;
};

export const TierStatus: FC<TierStatusProps> = ({ status, label, isHighLightened }: TierStatusProps) => {
  const isSuccessfullStatus = status === "yes";
  const Icon = isSuccessfullStatus ? UiCheckBoldIcon : UiCrossIcon;

  return (
    <div
      className={classNames(styles.tierStatus, {
        [styles.highlight]: isHighLightened,
      })}
    >
      {status === "other" ? (
        label
      ) : (
        <div
          className={classNames(styles.iconWrapper, {
            [styles.yesIcon]: isSuccessfullStatus,
            [styles.noIcon]: !isSuccessfullStatus,
          })}
        >
          <Icon />
        </div>
      )}
    </div>
  );
};
